import React from 'react'
import Sprite from './src/images/sprite.inline.svg'
import './src/styles/global.scss'
import { scrollToEstimate } from './src/utils/aimvpHelpers'
import { scrollToContactSection } from './src/utils/scrollToContactSection'

export const wrapPageElement = ({ element }) => {
  return (
    <>
      {element}
      <Sprite />
    </>
  )
}

const applyLiveRedirect = (pathname, force = false) => {
  if (typeof window === 'undefined') return Promise.resolve(false)
  if (typeof window.__applyCmsRedirect !== 'function') {
    return Promise.resolve(false)
  }
  return Promise.resolve(window.__applyCmsRedirect(pathname, force)).catch(
    () => false
  )
}

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  if (location?.hash) {
    return false
  }
  return true
}

export const onClientEntry = () => {
  applyLiveRedirect(window.location.pathname, true)
}

export const onPreRouteUpdate = ({ location }) => {
  applyLiveRedirect(location.pathname, true)
}

export const onRouteUpdate = ({ location }) => {
  applyLiveRedirect(location.pathname, true).then((redirected) => {
    if (redirected) return
    if (location?.hash === '#estimate') {
      window.setTimeout(() => {
        scrollToEstimate()
      }, 100)
      return
    }

    if (location?.hash === '#contact-us') {
      window.setTimeout(() => {
        scrollToContactSection()
      }, 100)
    }
  })
}
